
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Languages } from "../constants/data";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";


const DropDown = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState(Languages[0]); // Default to the first language

  useEffect(() => {
    // Retrieve the saved language from cookies
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      const language = Languages.find((lang) => lang.lang === savedLanguage);
      if (language) {
        setSelectedLanguage(language);
        i18n.changeLanguage(savedLanguage);
      }
    }
  }, [i18n]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageSelect = (language) => {
    i18n.changeLanguage(language.lang); // Change the language
    setSelectedLanguage(language); // Update the selected language
    Cookies.set("language", language.lang, { expires: 30 }); // Save the language in cookies for 7 days
    setIsOpen(false); // Close the dropdown
  };

  // Motion variants for dropdown open/close animation
  const dropdownVariants = {
    hidden: { opacity: 0, y: -10, transition: { duration: 0.2 } },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },

  };

  return (
    <div className="relative inline-block text-left">

      {/* Button with selected language */}
      <button
        onClick={toggleDropdown}
        className="px-4 py-2  text-white rounded-md flex items-center gap-4"

      >
        <img
          src={selectedLanguage.logo}
          alt={selectedLanguage.name}

          className="w-6 h-6 rounded-full"
        />
        {t(selectedLanguage.name)}
        <span>
          {isOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </span>
      </button>

      {/* AnimatePresence for dropdown */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={dropdownVariants}
            className={`absolute mt-2 w-48 bg-white rounded-md shadow-lg z-10 ${
              i18n.language === "en" ? "right-0" : "left-0"
            }`}
          >
            <ul className="py-1">
              {Languages.map((language, idx) => (
                <li
                  key={idx}
                  className={`${
                    selectedLanguage.name === language.name
                      ? "border-l-4 border-primary"
                      : ""
                  } px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer flex items-center gap-2`}
                  onClick={() => handleLanguageSelect(language)}
                >
                  <img
                    src={language.logo}
                    alt={language.name}
                    className="rounded-full w-6 h-6"
                  />
                  {t(language.name)}
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};


export default DropDown;

